import { render, staticRenderFns } from "./ResourcePublishComponent.vue?vue&type=template&id=75aff3d4"
import script from "./ResourcePublishComponent.vue?vue&type=script&lang=js"
export * from "./ResourcePublishComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports